import { IModalsService, IMODALS_SERVICE, P500UIBaseModal } from '@platform500services/p500-ui-kit';
import { Component, Inject } from '@angular/core';
import { IOnboardingTipsService } from '../../services/onboarding-tips/onboarding-tips.interface';
import { BreakpointObserver } from '@angular/cdk/layout';
import { filter, pluck } from 'rxjs/operators';
import { DestroySubscribers } from '../../decorators/destroy-subscribers.decorator';
import { Router } from '@angular/router';

@Component({
  selector: 'gtd-welcome',
  templateUrl: './welcome.modal.html',
})
@DestroySubscribers()
export class WelcomeModal extends P500UIBaseModal {
  public subscribers: any = {};

  constructor(
    @Inject(IMODALS_SERVICE) public modalsService: IModalsService,
    @Inject('IOnboardingTipsService') private onboardingTipsService: IOnboardingTipsService,
    public breakpointObserver: BreakpointObserver,
    router: Router
  ) {
    super(modalsService, router);
    this.subscribers.breakpointObserver = breakpointObserver
      .observe(['(max-width: 1000px)'])
      .pipe(
        pluck('matches'),
        filter((matches) => !!matches)
      )
      .subscribe(this.close.bind(this));
  }

  hideModal() {
    this.onboardingTipsService.toggleWelcomeModal();
    this.close();
  }

  disablesTips() {
    this.onboardingTipsService.setWorkingStatus(false);
    this.hideModal();
  }
}
